import { Controller } from "@hotwired/stimulus"

// Shrinks font size until the element text fits within its container width.
// Usage: <h1 data-controller="fit-text" data-fit-text-min-value="14">Long text</h1>
export default class extends Controller {
  static values = { min: { type: Number, default: 14 } }

  connect() {
    this.canvas = document.createElement("canvas")
    this.fit()
    this.observer = new ResizeObserver(() => this.fit())
    this.observer.observe(this.element.parentElement)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  fit() {
    const el = this.element
    // Reset font size to let CSS determine the starting size
    el.style.fontSize = ""

    const style = getComputedStyle(el)
    let size = parseFloat(style.fontSize)
    const font = `${style.fontWeight} ${size}px ${style.fontFamily}`
    const availableWidth = el.clientWidth

    const ctx = this.canvas.getContext("2d")
    ctx.font = font
    let textWidth = ctx.measureText(el.textContent).width

    while (size > this.minValue && textWidth > availableWidth) {
      size -= 1
      ctx.font = `${style.fontWeight} ${size}px ${style.fontFamily}`
      textWidth = ctx.measureText(el.textContent).width
    }

    if (size < parseFloat(style.fontSize)) {
      el.style.fontSize = `${size}px`
    }
  }
}
